module.exports = __webpack_public_path__ + "static/media/fullstack.e89a7f51.svg";